import _ from 'lodash'
import { diff } from '../lib/render-object'

const mapper = (text) => {
  return {
    'approles': 'Application Roles',
    'defaultportfolios': 'Default Portfolios',
  }[text] || _.startCase(text)
}

export const diffif = (props) => {
  if (props.resource !== 'portfolioasset') return null
  props.resource = 'portfolio'

  return () => {
    let change = JSON.parse(props.change)
    const diffs = diff(_.isEmpty(change.old) ? null : change.old, change.new, mapper)
    const atRest =
      props.method == 'POST' ? 'Add Portfolio Asset' : 
      props.method == 'DELETE' ? 'Delete Portfolio Asset' : 'Portfolio Change'

    return {diffs, atRest, ...props, _showCreate: true}
  }
}